<template lang="html">
  	<div class="">
        <p class="text-muted">Exports will be sent via email. Recurring options are coming soon. :)</p>
        <div class="alert alert-danger" v-if="Object.keys(errors).length > 0">
            <p><strong>Whoops!</strong> Something went wrong!</p>
            <br>
            <ul>
                <li v-for="error in errors">
                    {{ error[0] }}
                </li>
            </ul>
        </div>
        <form@submit.prevent="queueExport">
            <div class="form-group">
                <label for="type">Client</label>
                <select class="form-control" v-model="form.client" id="type">
                    <option :value="null">Select a Client</option>
                    <option v-for="client in clients" :value="client.slug">{{ client.name }}</option>
                </select>
            </div>
            <div class="form-group">
                <label for="type">Type</label>
                <select class="form-control" v-model="form.type" id="type">
                    <option :value="null">Select a Type</option>
                    <option value="ad-account">Ad Account</option>
                    <option value="campaign">Campaign</option>
                    <option value="campaign-competitive">Campaign Competitive</option>
                    <option value="ad-group">Ad Group</option>
                    <option value="device">Device</option>
                    <option value="keyword">Keyword</option>
                    <option value="search-ad">Search Ad</option>
                    <option value="image-ad">Image Ad</option>
                    <option value="social-ad">Social Ad</option>
                    <option value="social-ad-engagement">Social Ad Engagement</option>
                </select>
            </div>
            <div class="form-group">
                <label>Range</label>
                <div class="level">
                    <datepicker v-model="form.start" format="yyyy-MM-dd" icons-font="fa" placeholder="Start"></datepicker>
                    <datepicker v-model="form.end" format="yyyy-MM-dd" icons-font="fa" placeholder="End"></datepicker>
                </div>
            </div>
            <div class="form-group">
                <label for="increment">Increment</label>
                <select class="form-control" v-model="form.increment" id="increment">
                    <option :value="null">Select an Increment</option>
                    <option value="Total">Total</option>
                    <option value="Day">Day</option>
                    <option value="Month">Month</option>
                    <option value="Quarter">Quarter</option>
                    <option value="Year">Year</option>
                </select>
            </div>
            <div class="form-group">
                <label for="metrics">Metrics</label>
                <div id="metrics-container">
                    <v-select v-model="form.metrics" :options="metricsForType" options-value="val" multiple placeholder="Select Metrics"></v-select>
                </div>
            </div>
            <div class="form-group">
                <div style="font-weight:bold;">
                    Options
                </div>
                <div class="checkbox">
                    <label>
                        <input type="checkbox" v-model="form.byVendor"> Group By Vendor
                    </label>
                </div>
                <div class="checkbox" v-show="showByCampaign">
                    <label>
                        <input type="checkbox" v-model="form.byCampaign"> Group By Campaign
                    </label>
                </div>
                <div class="checkbox" v-show="showByMatchType">
                    <label>
                        <input type="checkbox" v-model="form.byMatchType"> Group By Match Type
                    </label>
                </div>
                <div class="checkbox" v-show="showZeroSpend">
                    <label>
                        <input type="checkbox" v-model="form.zeroSpend"> Include Items with Zero Spend
                    </label>
                </div>
            </div>
            <div class="form-group">
                <button class="btn btn-primary" type="submit" :class="{'btn-loading': loading}" :disabled="!submittable || loading">Export</button>
            </div>
  		</form>
  	</div>
</template>

<script>
import { datepicker, select } from 'vue-strap';

var Exports = require('./mixins/Exports');

export default {
    mixins: [Exports],

    components: { datepicker, vSelect: select },

    data() {
        return {
            form: {
                type: null,
                client: null,
                increment: null,
                start: '',
                end: '',
                metrics: [],
                byCampaign: false,
                byVendor: false,
                zeroSpend: false,
                byMatchType: false,
            }
        }
    },

    mounted() {
        this.getClients();
    },

    computed: {
        showByCampaign() {
            return this.form.type !== null && this.form.type !== 'ad-account' && this.form.type !== 'campaign' && this.form.type !== 'campaign-competitive';
        },
        showByMatchType() {
            return this.form.type === 'keyword';
        },
        showZeroSpend() {
            return this.form.type === 'keyword' || this.form.type === 'social-ad' || this.form.type === 'search-ad' || this.form.type === 'image-ad';
        },
        submittable() {
            return Object.values(this.form).filter(n => n === null || n === '').length === 0 && this.form.metrics.length > 0;
        },
        metricsForType() {
            let metrics = [
                {val: 'spend', label: 'Spend'},
                {val: 'impressions', label: 'Impressions'},
                {val: 'clicks', label: 'Clicks'},
                {val: 'conversions', label: 'Conversions'},
            ];

            if (this.form.type === null) {
                return metrics;
            } else if (this.form.type === 'social-ad-engagement') {
                return [
                    {val: 'shares', label: 'Shares'},
                    {val: 'page_likes', label: 'Page Likes'},
                    {val: 'comments', label: 'Comments'},
                    {val: 'reaction_like', label: 'Post Likes'},
                    {val: 'reactions', label: 'Reactions'},
                    {val: 'reaction_love', label: 'Reaction: Love'},
                    {val: 'reaction_wow', label: 'Reaction: Wow'},
                    {val: 'reaction_haha', label: 'Reaction: Haha'},
                    {val: 'reaction_sad', label: 'Reaction: Sad'},
                    {val: 'reaction_angry', label: 'Reaction: Angry'},
                    {val: 'reaction_thankful', label: 'Reaction: Thankful'},
                ]
            } else if (this.form.type === 'campaign-competitive') {
                return [
                    {val: 'search_impression_share', label: 'Search Impression Share'},
                    {val: 'search_lost_is_rank', label: 'IS Lost: Rank'},
                    {val: 'search_lost_is_budget', label: 'IS List: Budget'},
                ]
            }

            let types = {
                'ad-account': [
                    {val: 'average_position', label: 'Average Position'},
                ],
                'campaign': [
                    {val: 'average_position', label: 'Average Position'},
                ],
                'ad-group': [
                    {val: 'average_position', label: 'Average Position'},
                ],
                'keyword': [
                    {val: 'quality_score', label: 'Quality Score'},
                    {val: 'impression_share', label: 'Impression Share'},
                ],
                'device': [],
                'search-ad': [],
                'image-ad': [],
                'social-ad': [],
            };

            types[this.form.type].forEach((metric) => metrics.push(metric));

            return metrics;
        }
    },

    methods: {
        reset() {
            this.form = {
                type: null,
                client: null,
                increment: null,
                start: '',
                end: '',
                metrics: [],
                byCampaign: false,
                byVendor: false,
            }
        }
    }
}
</script>

<style lang="css" scoped>
    .level {
        display: flex;
        justify-content: space-between;
    }
    .datepicker {
        width: 48%;
    }

    #metrics-container > div {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/exports/PpcExportBuilder.vue